// 用户数据模块
import store from '../store'
import {getUserData,getUser,getUserAgreement,userlogout} from '../../axios/index.js';
import {
	IS_LOGIN,
	USER_INFO,
  	USER_TOKEN,
	USER_DATA,
	USER_AGREEMENT,
	MESSAGE_IDS,
	AGENT_INFO,
	AUTH_TYPE
} from '../types.js'


const state = {
	isLogin: sessionStorage.getItem("isLogin")?sessionStorage.getItem("isLogin"):false,
  userToken: null,
	userInfo: JSON.parse(sessionStorage.getItem('userInfo')),
	agentInfo: JSON.parse(sessionStorage.getItem('agentInfo')),
	userData: {}, //用户其他相关信息
	UserAgreement:{},
}

const actions = {
	// 获取用户信息
	getUserInfo({
		commit
	}, token = '') {
		return new Promise((resolve, reject) => {
			token && sessionStorage.setItem("token",token);
			getUser().then(res => {
        // console.log(res)
					if (res.code === 1) {
					  // console.log("getUserInfo:", res);
						commit('IS_LOGIN', true);
						commit('USER_INFO', res.data);
            sessionStorage.setItem("userInfo", JSON.stringify(res.data));
            // this.$router.go(-1); //返回上一层
						resolve(res)
					}
				}).then(() => {
					// 只有在登录的时候请求购物车信息，订单信息，获取登录信息之后。
					token && store.dispatch('getCartList');
					token && store.dispatch('getUserData');
					token && store.dispatch('getUserAgreement');
				})
				.catch(e => {
					reject(e)
				})
		})
	},
// 获取合同
	getUserAgreement({
		commit
	}) {
		return new Promise((resolve, reject) => {
			getUserAgreement().then(res => {
				console.log(res)
				commit('USER_AGREEMENT', res.data);
				resolve(res)
			}).catch(e => {
				reject(e)
			})
		})
	},
// 用户其他相关信息
	getUserData({
		commit
	}) {
		return new Promise((resolve, reject) => {
			getUserData().then(res => {
        // console.log(res)
				commit('USER_DATA', res.data);
				resolve(res)
			}).catch(e => {
				reject(e)
			})
		})
	},



	// 退出登录
	logout({
		commit
	}) {
		sessionStorage.getItem('token') && userlogout();

		sessionStorage.removeItem('token');
		sessionStorage.removeItem('session_key');
		sessionStorage.removeItem('userInfo');
		sessionStorage.removeItem('cartNum');
		sessionStorage.removeItem('chatSessionId');
		commit('IS_LOGIN', false);
		commit('USER_INFO', {});
		commit('CART_LIST', []);
		commit('CART_NUM');
		commit('USER_DATA', {});
		commit('USER_AGREEMENT', {});
	}
}

const mutations = {
	// 登录态
	[IS_LOGIN](state, data) {
    sessionStorage.setItem("isLogin",data)
		state.isLogin = data;
	},
	[USER_TOKEN](state,data){
		state.token = data;
	},
	// 用户信息
	[USER_INFO](state, data) {
		state.userInfo = data;
	},
	// 分销商信息
	[AGENT_INFO](state, data) {
		state.agentInfo = data;
	},
	// 小程序订阅消息模板ids
	[MESSAGE_IDS](state, data) {
		state.messageIds = data;
	},
	[USER_DATA](state, data) {
		state.userData = data;
	},
	[USER_AGREEMENT](state, data) {
		state.UserAgreement = data;
	},
	[AUTH_TYPE](state, data) {
		state.authType = data;
	},
	setTmpCart(state,data){ // 如果临时购物车不为空，那么下单显示临时购物车的东西；
		state.tmpCart = data;
	},
	clearTmpCart(state){
		state.tmpCart = null;
	}
}

const getters = {

}

// console.log("se isLogin:",sessionStorage.getItem('isLogin'));
export default {
	state,
	mutations,
	actions,
	getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js